import { Box, Container, Typography } from '@mui/material';
import { useCallback, useRef } from 'react';
import { PropertyCard, PropertyCardSkeleton } from '../../components/PropertyCard';

const PropertiesGrid = ({ properties, loading, categories, hasMore, loadMore, loadingMore }: any) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  const lastPropertyRef = useCallback(
    (node: HTMLElement | null) => {
      if (loadingMore) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadMore();
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [loadingMore, hasMore, loadMore]
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 3 }}>
        العقارات المتاحة
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gap: 3,
        }}
      >
        {loading
          ? [...Array(6)].map((_, i) => <PropertyCardSkeleton key={i} />)
          : properties.map((property: any, index: number) => (
              <Box
                key={property.id}
                ref={index === properties.length - 1 ? lastPropertyRef : null}
              >
                <PropertyCard property={property} categories={categories} />
              </Box>
            ))}

        {loadingMore &&
          [...Array(3)].map((_, i) => <PropertyCardSkeleton key={`loading-${i}`} />)}
      </Box>

      {!loading && !loadingMore && properties.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            لا توجد عقارات متاحة حالياً
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            جرب تغيير الفئة للعثور على عقارات أخرى
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default PropertiesGrid;
